import React from 'react';
import PropTypes from 'prop-types';

import ConfirmModal from './Confirm';
import ConfirmDeleteModal from './ConfirmDelete';

export default class UninstallDeleteAppModal extends React.PureComponent {
  static contextTypes = {
    notifyError: PropTypes.func.isRequired,
    notifySuccess: PropTypes.func.isRequired,
  };

  static propTypes = {
    app: PropTypes.object.isRequired,
    appStorefronts: PropTypes.array,
    uninstallApp: PropTypes.func.isRequired,
    deleteApp: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
  };

  shouldDelete() {
    const { app, appStorefronts } = this.props;

    // Delete if a theme was uploaded and has no more storefronts
    if (app.type === 'theme' && app.upload_theme) {
      if (appStorefronts?.length <= 0) {
        return true;
      }
    }

    return false;
  }

  onConfirm = async () => {
    const { notifyError, notifySuccess } = this.context;
    const { app, uninstallApp, deleteApp, onSuccess } = this.props;

    const shouldDelete = this.shouldDelete();
    const result = shouldDelete
      ? await deleteApp(app.id)
      : await uninstallApp(app.id);

    if (result?.errors) {
      notifyError(result.errors);
    } else {
      if (onSuccess) {
        await onSuccess(result);
      }

      notifySuccess(`${app.name} app uninstalled`);
    }
  };

  render() {
    const { app, appStorefronts } = this.props;

    const typeLabel = app.type === 'theme' ? 'theme' : 'app';
    const shouldDelete = this.shouldDelete(app);
    const actionLabel = shouldDelete ? 'Delete' : 'Uninstall';
    const actionLabelLower = actionLabel.toLowerCase();

    if (!shouldDelete && appStorefronts?.length > 0) {
      return (
        <ConfirmModal
          title={`${actionLabel} ${app.name}`}
          message={
            <p>
              You may not {actionLabelLower} this {typeLabel} while there are (
              {appStorefronts.length}) storefronts using it.
            </p>
          }
          actionHidden={true}
          cancelText="Ok"
        />
      );
    }

    return (
      <ConfirmDeleteModal
        titleMessage={`${actionLabel} ${app.name}`}
        message={
          <p>
            This will permanently remove the {typeLabel} and all of its data
            from your store. Proceed with caution.
          </p>
        }
        confirmInput={{
          description: `Enter the ${typeLabel} name to confirm`,
          value: app.name,
        }}
        action="Confirm"
        actionType="danger"
        loadingTitle={`${shouldDelete ? 'Deleting' : 'Uninstalling'} ${
          app.name
        }`}
        onConfirm={this.onConfirm}
      />
    );
  }
}
